import React from 'react'
import { SvgIcon } from '@material-ui/core'

// Double helix for germline SNV/Indel entry points (no DNA glyph ships with the
// installed icon sets). Stroke-only, so it takes the button's text colour.
const DnaIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinecap="round">
      <path d="M7 2c0 5 10 5 10 10s-10 5-10 10" />
      <path d="M17 2c0 5-10 5-10 10s10 5 10 10" />
      <path d="M8.9 5h6.2M8.9 9h6.2M8.9 15h6.2M8.9 19h6.2" />
    </g>
  </SvgIcon>
)

export default DnaIcon
